(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 989px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.markPast(true);
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.markPast(true);
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.markPast(false);
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    /* Dawn ran hide()/reveal() on EVERY scroll frame, even when nothing
       changed: class rewrites on the header, closing menu + search again
       (aria-expanded, body class) - each one a whole-page style recalc in
       Safari (~8 ms, ~15x per second while scrolling; 2026-11-03). Now
       every step only touches the DOM when the state actually changes. */
    markPast(on) {
      if (this.header.classList.contains('scrolled-past-header') !== on) this.header.classList.toggle('scrolled-past-header', on);
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.oaHold) return;
      const c = this.header.classList;
      if (c.contains('shopify-section-header-hidden') && c.contains('shopify-section-header-sticky')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      const c = this.header.classList;
      if (c.contains('shopify-section-header-sticky') && c.contains('animate') && !c.contains('shopify-section-header-hidden')) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      const c = this.header.classList;
      if (!c.contains('shopify-section-header-hidden') && !c.contains('shopify-section-header-sticky') && !c.contains('animate')) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  /* While a sheet hangs from the header (menu, filter), the header must stay
     put: show it if it was scrolled away and keep Dawn from hiding it again
     (iOS fires scroll events when the page locks). Returns the header's
     bottom edge for the sheet's top. */
  window.oaRevealHeader = function (hold) {
    var sh = document.querySelector('sticky-header');
    var sec = document.querySelector('.section-header');
    if (sh) sh.oaHold = !!hold;
    if (!hold) return 0;
    var wasHidden = sec && sec.classList.contains('shopify-section-header-hidden');
    if (wasHidden) sec.classList.remove('shopify-section-header-hidden');
    var el = sh || document.querySelector('.header-wrapper');
    if (!el) return 0;
    if (wasHidden) return Math.round(el.offsetHeight);
    return Math.max(0, Math.round(el.getBoundingClientRect().bottom));
  };

  } catch(e) { console.error(e); }
})();
})();
